var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ 'has-errors': _vm.hasErrors }},[_vm._t("default"),_vm._v(" "),_c('span',{staticClass:"error-message"},[_vm._v("\n    "+_vm._s(_vm.humanError)+"\n  ")])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }